// Whitelist of fields & categories backed by Coresignal direct support.
// Fields/categories not in this set are hidden from the UI in production mode.
// See coresignal-vs-juicebox.md for the parity matrix.

export const SUPPORTED_CATEGORIES = new Set([
  'general', 'locations', 'jobTitles', 'company',
  'industry', 'funding', 'skills', 'powerFilters',
  'education', 'languages', 'boolean',
]);

// Fields below the line are Coresignal-direct-supported (✅ in the matrix).
// Anything not listed gets hidden by FiltersModal.
export const SUPPORTED_FIELDS = new Set([
  // General
  'yearsOfExp', 'maxExp',
  // Locations  (locationRadius is ⚠ — drop)
  'locations', 'excludeDncCountries',
  // Job
  'jobTitles', 'pastJobTitles', 'timeCurrentRole', 'jobTitleLevels', 'jobTitleRoles',
  // Company
  'selectedCompanies', 'unselectedCompanies', 'dncCompanies', 'timeCurrentCompany', 'companySizes',
  // Industry
  'industries',
  // Funding & Revenue
  'fundingStages', 'minFunding', 'maxFunding', 'companyFoundedDate',
  // Skills
  'skills',
  // Power Filters — only the 4 derivable from data we have
  'pfFilterType',
  // Education  (minDegree=⚠, majors=❌ → drop)
  'selectedUnis', 'excludeUnis', 'uniLocations', 'gradYearStart', 'gradYearEnd',
  // Languages
  'languages',
  // Boolean & Name
  'fullName', 'booleanExpression',
]);

// Power-filters subset (4 of 10 are direct-supported via two-hop joins / array fields)
export const SUPPORTED_POWER_FILTERS = new Set([
  'vc_backed', 'founder', 'patents', 'publications',
]);
